import React, { useContext } from "react";

import {
  Heart,
  Home,
  Package,
  ShoppingCart,
} from "lucide-react";

import {
  Link,
  useLocation,
} from "react-router-dom";

import { CartContext } from "shared/contexts/Cart/CartContext";

import styles from "./DesktopPainel.module.scss";

import {
  Buscador,
  BuscadorProps,
} from "./headerbusca/buscador/Buscador";
import { PerfilUsuario } from "shared/contexts/Auth/AuthContext";

interface DesktopPainelProps {
  showSearch?: boolean;
  searchProps?: BuscadorProps;
  perfilAtivo: PerfilUsuario;
}

export const DesktopPainel: React.FC<DesktopPainelProps> = ({
  showSearch = true,
  searchProps,
  perfilAtivo,
}) => {
  const location = useLocation();

  const { cartQtd } = useContext(CartContext);

  return (
    <header className={styles.header}>
      <div className={styles.container}>

        {/* =================================
            BUSCADOR
        ================================= */}

        {showSearch && (
          <div className={styles.busca}>
            <Buscador
              {...searchProps}
              perfilAtivo={perfilAtivo}
            />
          </div>
        )}

        {/* =================================
            NAVEGAÇÃO
        ================================= */}

        <nav className={styles.nav}>
          {/* =================================
              HOME
          ================================= */}

          <Link
            to="/"
            className={`${styles.navItem} ${
              location.pathname === "/"
                ? styles.active
                : ""
            }`}
          >
            <Home size={20} />

            <span>
              Home
            </span>
          </Link>

          {/* =================================
              PEDIDOS
          ================================= */}

          <Link
            to="/minhascompras"
            className={`${styles.navItem} ${
              location.pathname === "/minhascompras"
                ? styles.active
                : ""
            }`}
          >
            <Package size={20} />

            <span>
              Pedidos
            </span>
          </Link>

          {/* =================================
              FAVORITOS
          ================================= */}

          <Link
            to="/favoritos"
            className={`${styles.navItem} ${
              location.pathname === "/favoritos"
                ? styles.active
                : ""
            }`}
          >
            <Heart size={20} />

            <span>
              Favoritos
            </span>
          </Link>

          {/* =================================
              CARRINHO
          ================================= */}

          <Link
            to="/carrinho"
            className={`${styles.navItem} ${
              location.pathname === "/carrinho"
                ? styles.active
                : ""
            }`}
          >
            <div className={styles.iconContainer}>

              <ShoppingCart size={20} />

              {cartQtd > 0 && (
                <span className={styles.badge}>
                  {cartQtd}
                </span>
              )}

            </div>

            <span>
              Carrinho
            </span>
          </Link>

        </nav>

      </div>
    </header>
  );
};